import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// ==============================|| REQUIRE ADMIN ACCESS GUARD ||============================== //
// Nests inside AuthGuard - blocks Uživatelé/Skupiny for anyone who is
// neither superadmin nor a delegated group-admin of at least one group
// (mirrors the in-controller scoping AdminUserController::index()/
// AdminGroupController::index() already do - see /auth/me's admin_access,
// 2026-08-21).
//
// Deliberately NOT replaced by the generic RequireModuleAccess (2026-08-22,
// "core_modules" katalog) - Uživatelé/Skupiny are gated by group-admin
// DELEGATION (core_group_admins), which is a separate concept from a
// module_key permission grant and has no core_modules row of its own.

export default function RequireAdminAccess({ children }) {
  const { status, user } = useAuth();

  if (status === 'loading') return <Loader />;

  const access = user?.admin_access;
  if (!access?.is_system_admin && !access?.is_group_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

RequireAdminAccess.propTypes = { children: PropTypes.node };
